import { useCallback, useEffect, useRef } from "react";
import {
  closeGame,
  getGameNav,
  goBack,
  goForward,
  goTo,
  openGame,
  subscribeGameNav,
} from "../../utils/mymGameHistory";

/**
 * Bind a game's local React screens to the shared MYM history stack.
 * onScreen is called on browser Back/Forward and on mount hydration.
 */
const useGameHistory = ({ game, onScreen } = {}) => {
  const onScreenRef = useRef(onScreen);
  onScreenRef.current = onScreen;

  useEffect(() => {
    if (!game) return undefined;

    const apply = (nav, reason) => {
      if (!onScreenRef.current) return;
      if (!nav) {
        // Parent /mindyourmusic owns modal close. Standalone game pages treat
        // a missing nav entry as the landing screen.
        if (typeof window !== "undefined" && window.top !== window) return;
        onScreenRef.current("home", null, reason);
        return;
      }
      if (nav.game !== game) return;
      onScreenRef.current(nav.screen, nav.data, reason);
    };

    const unsub = subscribeGameNav(apply);
    apply(getGameNav(), "hydrate");
    return unsub;
  }, [game]);

  const handleGoTo = useCallback(
    (screen, data) => goTo({ game, screen, data }),
    [game],
  );

  const handleOpen = useCallback(
    (opts) => openGame({ game, ...opts }),
    [game],
  );

  return {
    goTo: handleGoTo,
    goBack,
    goForward,
    openGame: handleOpen,
    closeGame,
    getState: getGameNav,
  };
};

export default useGameHistory;
